module.exports = __webpack_public_path__ + "static/media/python.fbea4488.svg";